import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "button"]

  connect() {
    this._onDocClick = this._onDocClick.bind(this)
    document.addEventListener("click", this._onDocClick)
  }

  disconnect() {
    document.removeEventListener("click", this._onDocClick)
  }

  open()   { this.menuTarget.classList.remove("hidden") }
  close()  { this.menuTarget.classList.add("hidden") }
  toggle(event) {
    event.preventDefault()
    this.menuTarget.classList.toggle("hidden")
  }

  _onDocClick(event) {
    if (!this.element.contains(event.target)) this.close()
  }
}
